import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { cn } from '@mdvip/shared/lib/utils';
import '@mdvip/shared/lib/uiModality';

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer relative flex size-5 shrink-0 items-center justify-center rounded-[4px] border border-input shadow-xs transition-shadow outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 [@media(pointer:coarse)]:after:-inset-x-3.5 [@media(pointer:coarse)]:after:-inset-y-3.5 data-disabled:cursor-not-allowed data-disabled:opacity-50 aria-invalid:border-2 aria-invalid:border-destructive-foreground aria-invalid:bg-[color-mix(in_oklab,var(--destructive)_14%,var(--card))] aria-invalid:aria-checked:border-primary dark:bg-input/30 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <Icon name="check" weight="solid" size="sm" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
